import IpubEmpty from './src/main'

/* istanbul ignore next */
IpubEmpty.install = function(Vue) {
  Vue.component(IpubEmpty.name, IpubEmpty)
}

export default IpubEmpty
